// removed by extract-text-webpack-plugin
module.exports = {"snackbar":"theme__snackbar___27RjK","accept":"theme__accept___16cwG","button":"theme__button___1UIi0","warning":"theme__warning___3DT4-","cancel":"theme__cancel___3vKcn","active":"theme__active___3AbAz","label":"theme__label___38ZHp"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/snackbar/theme.css
// module id = 1202
// module chunks = 0